import { v4 as uuidv4 } from 'uuid'
import { mapPlanningType } from '@/views/ground-station/components/dictionary'
const state = {
    // 地面站版本
    gsVersion: 1, // 1是专业版，2是教育版
    // 是否打开电子围栏弹窗
    popoverVisible_electronicFence: false,
    // 是否打开云台AI功能列表弹窗
    popoverVisible_gbAiList: false,
    // 是否打开垂起固定翼扫描航线
    scanRouteVisible: false,
    // 当前选中无人机是否在线
    activeUavOnline: false,
    // 当前地图上的操作 1：航线规划，2：归航点，3：指点飞行，4：地图测量，5：机头指向目标点地图选点，6：高级平移地图选点，7：电子围栏，8：起飞点
    currentInteraction: undefined,
    ...mapPlanningType,
    // 电子围栏数据
    // electronicFence: JSON.stringify([{ lng: 116.16726100444795, lat: 40.196339288815075 }, { lng: 116.1687469482422, lat: 40.19647450757957 }, { lng: 116.16889715194704, lat: 40.195392749913744 }, { lng: 116.1673790216446, lat: 40.19526572420718 }, { lng: 116.1681354045868, lat: 40.19591724063413 }])
    electronicFence: ''
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
    stopMapInteraction(state, payload) {
        for (const key in mapPlanningType) {
            if (!Object.prototype.hasOwnProperty.call(mapPlanningType, key)) continue;
            if (key === payload) continue
            state[key] = uuidv4()
        }
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
